import React from 'react'
import { ApkFile } from 'domain/ApkFile'
import NoIcon from 'assets/images/app-no-icon.png'

export const initFile = (
    file: File,
    data: string | ArrayBuffer | null | undefined,
): ApkFile =>
    Object.assign({
        ...file,
        data,
    }) as ApkFile

export const readFileBlob = (file: File): Promise<ApkFile> => {
    const reader = new FileReader()
    return new Promise<ApkFile>(resolve => {
        reader.onload = event => {
            const target = event.target
            resolve(initFile(file, target?.result))
        }
        reader.readAsDataURL(file)
    })
}

export const onImageLoadError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>,
) => {
    e.currentTarget.onerror = null
    e.currentTarget.src = NoIcon
}

export const validateAppImageDimensions = (file: ApkFile) => {
    const maxWidth = 512
    const maxHeight = 512
    const image = new Image()

    image.src = file.data as string

    return new Promise<boolean>(resolve => {
        image.onload = (ev: any) => {
            const height = ev?.height || 0
            const width = ev.width || 0

            console.log('width', width, 'height:', height)

            if (height > maxHeight || width > maxWidth) {
                resolve(false)
            } else {
                resolve(true)
            }
        }
    })
}
